module.exports = __webpack_public_path__ + "img/17.52b6aea3.png";